import { SERVICES_CYCLIC_DEPENDENCY } from '../constants/error-messages';
/**
 * 模块Holder，用于在DI框架中保存模块的构造函数和模块实例
 */
export class ServiceHolder {
    // ServiceHolder的descriptor可能为null
    constructor(instance, descriptor) {
        this.instance = instance;
        this.descriptor = descriptor;
    }
}
/**
 *  循环依赖异常告警
 */
export class CyclicDependencyError extends Error {
    constructor(graph) {
        super(SERVICES_CYCLIC_DEPENDENCY);
        this.message = graph.toString();
    }
}
//# sourceMappingURL=typing.js.map